import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { resultCardStyles } from 'marketplace-ui-common/storefront/utils/resultCardStyles';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import CollectionCard from 'marketplace-ui-common/collections/components/CollectionCard'; // @ts-expect-error untyped dependency

import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { usePublishedAppCollections } from '../hooks/usePublishedAppCollections';
const MAX_COLLECTIONS_PER_PAGE = 24;
const StyledCollectionCard = styled(CollectionCard).withConfig({
  displayName: "AppCollectionsSection__StyledCollectionCard",
  componentId: "sc-1f3txqz-0"
})(["", ""], resultCardStyles);
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "AppCollectionsSection__StyledRouterLink",
  componentId: "sc-1f3txqz-1"
})(["display:flex;align-items:stretch;"]);
export default function AppCollectionsSection({
  trackInteraction
}) {
  const {
    className,
    columns
  } = useResponsiveProps({
    className: {
      [ScreenSizes.MD]: undefined,
      [ScreenSizes.LG]: 'p-bottom-10 p-x-5 m-x-15'
    },
    columns: {
      [ScreenSizes.SM]: 1,
      [ScreenSizes.MD]: 2,
      [ScreenSizes.LG]: 3
    }
  });
  const {
    getDisplayedCollections,
    requestState: publishedAppCollectionsRequestState
  } = usePublishedAppCollections();
  const displayedCollections = getDisplayedCollections();
  const [page, setPage] = useState(1);
  const offset = useMemo(() => (page - 1) * MAX_COLLECTIONS_PER_PAGE, [page]);
  const limit = useMemo(() => displayedCollections.length && displayedCollections.length <= MAX_COLLECTIONS_PER_PAGE * page ? displayedCollections.length : offset + MAX_COLLECTIONS_PER_PAGE, [displayedCollections, offset, page]);
  const pageCount = Math.ceil(displayedCollections.length / MAX_COLLECTIONS_PER_PAGE);
  const needsPagination = pageCount > 1;
  const currentCollections = useMemo(() => {
    return displayedCollections.slice(offset, limit);
  }, [displayedCollections, offset, limit]);
  const handlePageChange = useCallback(newPage => {
    setPage(newPage);
    trackInteraction('change collections page', {
      pageNumber: newPage
    });
  }, [trackInteraction]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: publishedAppCollectionsRequestState,
    children: /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(UICardGrid, {
        columns: columns,
        className: className,
        children: currentCollections.map(collection => {
          const slug = collection.publishedListing ? collection.publishedListing.slug : null;
          return slug ? /*#__PURE__*/_jsx(StyledRouterLink, {
            onClick: () => trackInteraction('click collection', {
              category: 'featured apps',
              value: slug,
              pageNumber: page
            }),
            to: `/${slug}`,
            use: "unstyled",
            children: /*#__PURE__*/_jsx(StyledCollectionCard, {
              collection: collection,
              descriptionI18nKey: `appMarketplace.collections.collection_${collection.id}.description`,
              titleI18nKey: `appMarketplace.collections.collection_${collection.id}.name`
            })
          }, `collection-${collection.id}`) : null;
        })
      }), needsPagination && /*#__PURE__*/_jsx(UIPaginator, {
        onPageChange: ({
          target: {
            value
          }
        }) => handlePageChange(value),
        pageCount: pageCount
      })]
    })
  });
}